export default "__VITE_ASSET__Cwv_5kjQ__"